import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Posts from "../../api-calls/Posts";
import { selectLoginToken } from "../../features/states/slices";
import { fetchUserInfo } from "./accountDataServices";

function createUserNameSchema() {
    return Yup.object().shape({
        username: Yup.string().test(
            "username",
            "Must be a valid userID",
            (value) => Yup.string().matches(/^.*#.*$/, "Must be a valid userID").isValidSync(value)
        ),
    });
}

export default function useUserNameInputModel() {
    const userInfo = useSelector(selectLoginToken);
    const navigate = useNavigate();

    const validationSchema = useMemo(() => createUserNameSchema(), []);

    const handleSubmitUsername = useCallback(
        async (data) => {
            const userName = {
                id: userInfo.userId,
                displayName: data.username,
            };

            const response = await Posts(userName, "User/update-display-name");
            if (response.code === 200) {
                const userInfoResponse = await fetchUserInfo();
                if (userInfoResponse?.id) {
                    navigate("/");
                }
                return;
            }

            console.error("Error updating username:", response.message);
        },
        [navigate, userInfo.userId]
    );

    return {
        validationSchema,
        handleSubmitUsername,
    };
}
